import {
    setDatesForcedByActivation,
    setFilterCompare,
    setFilterDate,
    setFilterDateCompare,
    setSearchPerfDateOverridden,
} from 'src/context/reducers/filter-settings/filterSlice';

export interface SearchPerformanceDateRange {
    workspaceId: string | number | null;
    start: string;
    end: string;
    compareStart: string | null;
    compareEnd: string | null;
    compare: boolean;
}

let appliedDateRange: SearchPerformanceDateRange | null = null;

export const isSearchPerformancePath = (pathname?: string | null) =>
    Boolean(
        pathname &&
        (
            pathname.includes('/search-performance/') ||
            pathname.endsWith('/search-performance')
        )
    );

export const rememberSearchPerformanceDateRange = (
    range: SearchPerformanceDateRange
) => {
    appliedDateRange = { ...range };
};

export const getSearchPerformanceDateRange = (
    workspaceId?: string | number | null
) => {
    if (!appliedDateRange) return null;

    if (
        workspaceId != null &&
        appliedDateRange.workspaceId != null &&
        String(appliedDateRange.workspaceId) !== String(workspaceId)
    ) {
        appliedDateRange = null;
        return null;
    }

    return { ...appliedDateRange };
};

export const restoreSearchPerformanceDateRange = (
    dispatch: any,
    workspaceId?: string | number | null
) => {
    const range = getSearchPerformanceDateRange(workspaceId);

    if (!range) return false;

    dispatch(setSearchPerfDateOverridden(true));
    dispatch(setDatesForcedByActivation(false));
    dispatch(
        setFilterDate({
            start: range.start,
            end: range.end,
            skipAlignment: true,
        })
    );

    if (range.compareStart && range.compareEnd) {
        dispatch(
            setFilterDateCompare({
                compareStart: range.compareStart,
                compareEnd: range.compareEnd,
                skipAlignment: true,
            })
        );
    }

    dispatch(setFilterCompare(range.compare));

    return true;
};